"use strict";

exports.__esModule = true;
exports["default"] = void 0; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
// ----------------------------------------------------------------------------
// ------------------------------------------------------------------- Function
// ----------------------------------------------------------------------------

/** resetShoppingCart */

var resetShoppingCart = function resetShoppingCart(defaultState, previousState, payload) {
  return Object.assign({}, previousState, {
    shoppingCartState: {
      objectsList: [],
      objectsCounts: {},
      totalCountOfObjects: 0,
      totalPriceOfObjects: 0,
      thatTotalPriceOfObjects: 0,
      thisTotalPriceOfObjects: 0
    }
  });
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = resetShoppingCart;
exports["default"] = _default;
module.exports = exports.default;